























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';

@Component
export default class FloatLabelInput extends Vue {
  @Prop()
  value: string;

  @Prop()
  id: string;

  @Prop({ default: 'text' })
  type: string;

  @Prop()
  label: string;

  @Prop({ default: false })
  required: boolean;

  @Prop({ default: ' ' })
  placeholder: string;

  @Prop({ default: 'on' })
  autocomplete: string;

  @Prop({ default: 150 })
  maxInputHeight: number;

  internalValue: string = null;

  get isTextarea(): boolean {
    return this.type === 'textarea';
  }

  mounted() {
    this.internalValue = this.value;
    if (this.isTextarea) {
      const element = this.$refs.textarea as HTMLElement;
      element.style.boxSizing = 'border-box';
      const offset = element.offsetHeight - element.clientHeight;
      element.addEventListener('input', () => {
        this.resize(element, offset);
      });

      this.$nextTick(() => {
        this.resize(element, offset);
      });
    }
  }

  resize(element: any, offset: any) {
    if (element.offsetHeight < this.maxInputHeight) {
      (element as any).style.height = 'auto'; // eslint-disable-line
      (element as any).style.height = (element as any).scrollHeight + offset + 'px'; // eslint-disable-line
    }
  }

  focus() {
    if (this.isTextarea) {
      (this.$refs.textarea as HTMLElement).focus();
    } else {
      (this.$refs.input as HTMLElement).focus();
    }
  }

  @Watch('internalValue')
  valueChanged(newValue: string) {
    this.$emit('input', newValue);
  }
}
